import React from 'react';
import styled from 'styled-components';

import type { BaseLayoutProps } from '@typings/layout.ts';

import findByLayoutId from '../../utils/findByLayoutId.ts';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(500px, 35%) minmax(65%, 1fr);
  grid-template-areas:
    'header main'
    'content main'
    'cta cta';
  height: 100%;
  grid-template-rows: minmax(80px, 151px) 1fr 100px;
`;

const Main = styled.div`
  grid-area: main;
  height: 100%;
  position: relative;
`;

const Header = styled.header`
  grid-area: header;
`;

const Content = styled.div`
  grid-area: content;
  min-height: 10em;
  overflow-y: auto;
  scroll-behavior: smooth;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Navigation = styled.div`
  grid-area: cta;
`;

const AttractLoop = styled.div`
  position: absolute;
  top: 0;
  inset-inline-start: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
`;

export default function StandardLayout({ app, children }: BaseLayoutProps) {
  const header = findByLayoutId('header', children, app);
  const content = findByLayoutId('content', children, app);
  const map = findByLayoutId('map', children, app);
  const appInfo = findByLayoutId('appInfo', children, app);
  const main = findByLayoutId('main', children, app);
  const navigation = findByLayoutId('navigation', children, app);
  const attractLoop = findByLayoutId('attractLoop', children, app);
  return (
    <Wrapper>
      {attractLoop.length > 0 && <AttractLoop>{attractLoop[0]}</AttractLoop>}
      <Header>{header}</Header>
      <Content>{content}</Content>
      <Main>{main.length === 0 ? [...map, ...appInfo] : main}</Main>
      <Navigation>{navigation}</Navigation>
    </Wrapper>
  );
}
